import { IUser } from '../../../extViewmodels';
import { SortOptions } from '../../components/LeaderboardComponents/components/ListHeader';
import { useErrorMessages, useGamification } from '../../hooks';
import { formatOptional, formatUser } from '../utils/criteriaBuilder';
import { useStatesOnFetch } from '../utils/useStatesOnFetch';
import {
	ILeaderboard,
	ILeaderboardFilterCriteria,
	LeaderboardFilterCriteriaProperty,
} from './../../viewModels/gamification';

export interface ILeaderboardFilter {
	Manager?: IUser;
	OfficeLocation?: string;
	QuotaTeam?: string;
	Team?: string;
	User?: IUser;
	UserRole?: string;
	Vertical?: string;
}

function filterToCriteria(filter: ILeaderboardFilter): ILeaderboardFilterCriteria[] {
	const criteria: ILeaderboardFilterCriteria[] = [];

	criteria.push(
		formatUser<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.Manager, filter?.Manager)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.Team, filter?.Team)
	);

	criteria.push(formatUser<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.User, filter?.User));
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.UserRole, filter?.UserRole)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.Vertical, filter?.Vertical)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(LeaderboardFilterCriteriaProperty.QuotaTeam, filter?.QuotaTeam)
	);
	criteria.push(
		formatOptional<LeaderboardFilterCriteriaProperty>(
			LeaderboardFilterCriteriaProperty.OfficeLocation,
			filter?.OfficeLocation
		)
	);

	return criteria.filter(item => !!item);
}

interface IParams {
	asc?: boolean;
	filter: ILeaderboardFilter;
	sortBy: SortOptions;
}

export const useLeaderboard = () => {
	const { state, handleWorking, handleResponse, reset } = useStatesOnFetch<ILeaderboard>();

	const errorMessages = useErrorMessages();

	const gamification = useGamification();

	const get = async ({ asc, filter, sortBy }: IParams) => {
		handleWorking();
		const criteria = filterToCriteria(filter);
		try {
			await gamification.getUserLeaderboardFiltered(criteria, sortBy, asc);

			const response = { value: gamification.userLeaderboard };
			handleResponse(response);
			return response;
		} catch (error) {
			errorMessages.pushApiError(error);
		}
	};

	return {
		...state,
		empty: !state?.data,
		get,
		reset,
		status: state.status,
	};
};
